<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="onRefresh()"
        tabindex="0"
        (keydown.enter)="onRefresh()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">FOTA Batch</span>
    </div>

    @if (createFota) {
      <div class="button-group">
        <button
          type="button"
          class="primary-button"
          [disabled]="!createFota"
          (click)="createnew()"
        >
          Create New Batch <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
        <button
          type="button"
          class="primary-button"
          [disabled]="!createFota"
          (click)="openManualFotaPage()"
        >
          Manual FOTA <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      </div>
    }
  </div>

  @if (viewFota === true) {
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">FOTA Batch List</h6>
        <div class="component-actions">
          <app-common-search
            (searchSubmit)="onKeyUpEventBatchList($event)"
          ></app-common-search>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Batch ID</th>
              <th>Batch Name</th>
              <th>Batch Description</th>
              <th>Created By</th>
              <th>Created At</th>
              <th>Batch Breakdown</th>
              <th>Completed Percentage</th>
              <th>Batch Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @for (devicevalue of listOfBatch; track devicevalue) {
              <tr>
                <td>{{ devicevalue.batchId }}</td>
                <td>{{ devicevalue.batchName }}</td>
                <td>{{ devicevalue.batchDesc }}</td>
                <td>
                  {{ devicevalue.createdBy }}
                </td>
                <td>
                  {{ devicevalue.createdAt | date: 'dd MMM yyyy | hh:mm:ss a' }}
                </td>
                <td>
                  C-{{ devicevalue.completeCount }} | A-{{
                    devicevalue.abortCount
                  }}
                  | IP-{{ devicevalue.inprogressCount }} | T-{{
                    devicevalue.totalCount
                  }}
                </td>
                <td>{{ devicevalue.percentage }} %</td>
                <td>
                  <div class="status-container">
                    {{ devicevalue.batchStatus }}
                    <mat-icon
                      class="btn-icon"
                      [ngClass]="{
                        green: devicevalue.batchStatus === 'Completed',
                        yellow: devicevalue.batchStatus === 'In Progress',
                        red: devicevalue.batchStatus === 'Aborted',
                        grey: devicevalue.batchStatus === 'Not Started',
                      }"
                      [matTooltip]="devicevalue.batchStatus"
                      >circle</mat-icon
                    >
                  </div>
                </td>
                <td>
                  <div class="action-buttons">
                    <button
                      type="button"
                      class="primary-button view-button"
                      (click)="view(devicevalue.batchId)"
                    >
                      <mat-icon class="btn-icon">visibility</mat-icon>
                    </button>
                    @if (deleteFota) {
                      <button
                        type="button"
                        class="primary-button abort-button"
                        (click)="deleteBatch(devicevalue.batchId)"
                        [disabled]="
                          devicevalue.percentage === 100 ||
                          devicevalue.inprogressCount === 0
                        "
                      >
                        <mat-icon class="btn-icon">block</mat-icon>
                      </button>
                    }
                    <button
                      type="button"
                      class="primary-button export-button"
                      (click)="exportToExcel(devicevalue.batchId)"
                    >
                      <mat-icon class="btn-icon">file_download</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
          @if (listOfBatch.length < 1) {
            <tbody>
              <tr>
                <td colspan="9">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (listOfBatch.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
